export default __webpack_public_path__ + "static/media/verified-sign.f4dc1d63.svg";